import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";
import {getCornerSale, getCornerSaleDaily} from "../../../../../api/api";
import {Loading} from "../../../../../components/common";
import {currencyFormatter} from "../../../../../config/formatter";
import * as formatter from "../../../../../config/formatter";
import {gridColumnSum} from "../../../../../config/common";

const {RangePicker} = DatePicker;
const CornerHourlySaleReport = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [headerData, setHeaderData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", cornerCd: "", saleHour: "",
        fromSaleDt: dayjs(), toSaleDt: dayjs()
    });

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const timeValueGetter = (params) => {
        const saleHour = params.data.saleHour;
        return saleHour + "시";
    }

    const [hourlyHeaderDef] = useState([
        {headerName: "No", maxWidth: 40, valueGetter: "node.rowIndex + 1", cellClass: "static-cell"},
        {field: "saleHour", headerName: "시간대", minWidth: 80, valueGetter: timeValueGetter},
        {field: "saleQty", headerName: "판매수량", valueFormatter: currencyFormatter, cellClass: "number-cell"},
        {
            field: "payAmt",
            headerName: "실매출액",
            valueFormatter: currencyFormatter,
            cellClass: "number-cell",
            cellStyle: {color: "blue", cursor: "pointer"}
        },
    ]);

    const [columnDefs] = useState([
        {field: "saleDt", headerName: "판매일자", minWidth: 100, cellClass: "static-cell"},
        {field: "cornerNm", headerName: "업체구분"},
        {field: "saleDt", headerName: "요일", valueFormatter: (e) => formatter.weekendFormatter(e, "YYYYMMDD"), minWidth: 30},
        {field: "saleAmt", headerName: "총매출액", valueFormatter: currencyFormatter, cellClass: "number-cell"},
        {field: "dcAmt", headerName: "총할인", valueFormatter: currencyFormatter, cellClass: "number-cell"},
        {field: "payAmt", headerName: "실매출액", valueFormatter: currencyFormatter, cellClass: "number-cell"},
        {field: "saleQty", headerName: "판매수량", valueFormatter: currencyFormatter, cellClass: "number-cell"},
        {field: "bagPrice", headerName: "봉투", valueFormatter: currencyFormatter, cellClass: "number-cell"},
    ]);

    useEffect(() => {

    }, []);

    const onGridReady = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, [])

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    const search = () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            cornerCd: cornerCd,
            saleHour: searchForm.saleHour,
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        setLoading(true);
        o2Api.getCornerSaleHourly(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setHeaderData(responseBody);
                createStatTotalRowData(responseBody);
            }
        });
    };

    const createStatTotalRowData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            hour: "합계",
            saleQty: gridColumnSum(data, 'saleQty'),
            payAmt: gridColumnSum(data, 'payAmt')
        });
        api.setPinnedBottomRowData(result);
    };

    const detail = (e) => {
        const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            cornerCd: cornerCd,
            saleHour: e.data.saleHour + "",
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        setLoading(true);
        o2Api.getCornerSaleHourlyDetail(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setGridData(responseBody);
                createDetailRowData(responseBody);
            }
        });
    }

    const createDetailRowData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            cornerNm: "합계",
            saleAmt: gridColumnSum(data, 'saleAmt'),
            dcAmt: gridColumnSum(data, 'dcAmt'),
            payAmt: gridColumnSum(data, 'payAmt'),
            netAmt: gridColumnSum(data, 'netAmt'),
            vatAmt: gridColumnSum(data, 'vatAmt'),
            bagPrice: gridColumnSum(data, 'bagPrice'),
            saleQty: gridColumnSum(data, 'saleQty')
        });
        api.setPinnedBottomRowData(result);
    };

    const onCellClicked = (e) => {
        switch (e.colDef.field) {
            case "payAmt":
                detail(e);
                break;
        }
    };

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}
                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>

                    <StoreCornerListWhere type={"O"} account={props.account} selected={searchForm}
                                          onSelect={(c, v) => handleSelect(c, v)}/>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 100}}>조회일자</CInputGroupText>
                            <CInputGroupText style={{background: "white", height: 32}}>
                                <RangePicker bordered={false}
                                             separator={"~"}
                                             placeholder={""}
                                             locale={locale}
                                             value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
                                             onChange={(dayjs, dateString) => {
                                                 setSearchForm((state) => ({
                                                     ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
                                                 }));
                                             }}/>
                            </CInputGroupText>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CButton size={"sm"} onClick={search}>조회</CButton>
                    </CCol>
                </CForm>

                <div style={{height: 10}}/>
                <CRow>
                    <CCol xs={4}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            시간대별
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
                            <AgGridReact
                                ref={gridRef}
                                onGridReady={onGridReady}
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={headerData}
                                animateRows={true}
                                onCellClicked={onCellClicked}
                                defaultColDef={defaultColDef}
                                columnDefs={hourlyHeaderDef}>
                            </AgGridReact>
                        </div>
                    </CCol>
                    <CCol>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            매출상세
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
                            <AgGridReact
                                ref={gridRef}
                                onGridReady={onGridReady}
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={gridData}
                                animateRows={true}
                                defaultColDef={defaultColDef}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(CornerHourlySaleReport);
